module.exports = __webpack_public_path__ + "img/1009_sp.02fbc6b4.gif";